import VitalChart from './vital-chart';
import VitalChartEmpty from './vital-chart-empty';

export default VitalChart;

export { VitalChartEmpty };
